let globalDeferredPrompt = null;

if ('onbeforeinstallprompt' in window) {
    window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        globalDeferredPrompt = e;

        // Dispatch custom event to notify Vue components
        window.dispatchEvent(new CustomEvent('app-install-prompt-ready', {
            detail: { prompt: e }
        }));
    });
} else {
    console.log('[InstallPrompt] beforeinstallprompt NOT supported on this browser');
}

// Export getter for composable to access the prompt
export function getDeferredPrompt() {
    return globalDeferredPrompt;
}

// Export setter to clear the prompt after use
export function clearDeferredPrompt() {
    globalDeferredPrompt = null;
}
